import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const underwriterApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  reducerPath: 'underwriterApi',
  tagTypes: ['Underwriter'],
  endpoints: () => ({})
})

export default underwriterApi
